//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProductCta',
  computed: {
    show() {
      return (
        this.$store.getters['user/isGuest'] && !this.$store.state.ui.hideFooter
      )
    },

    ctaLink() {
      return this.$route.path === '/get_started'
        ? {
            url: '/get_started/quiz',
            label: 'Take the Quiz'
          }
        : {
            url: '/get_started',
            label: 'Get Started'
          }
    }
  }
}
